import React from "react";

class PaymentPlayground extends React.Component {
  render() {
    var Mode = "0";
    var MerchantID = "F3CCB041-2AEB-4289-86A2-A3329DBDDED7";
    var ApplicationID = "BBA6CF97-C116-4536-A3B2-0D32861912C6";
    var Price = "10.00";
    var Currency = "ZAR";
    var MerchantReference = "SUREQUOTEUSER:14";
    var RedirectSuccess = "http://localhost:8080/payment/process";
    var RedirectFailed = "http://localhost:8080/payment/process";

    var Title = "Node.JS Virtual 3D Secure";

    return (
      <React.Fragment>
        <h1>{Title}</h1>
        <form
          name="PostTest"
          action="https://virtual.mygateglobal.com/PaymentPage.cfm"
          method="post"
        >
          <table
            width="800"
            border="0"
            cellpadding="0"
            cellspacing="0"
            bordercolor="#f8f9e8"
          >
            <tr valign="top">
              <td height="500">
                <table border="0">
                  <tr>
                    <th rowspan="2">
                      <br />
                    </th>
                    <th align="left">Payment Amount:</th>
                    <td width="5">&nbsp;</td>
                    <td>{Price}</td>
                  </tr>
                  <tr>
                    <th align="left">Payment For:</th>
                    <td width="5">&nbsp;</td>
                    <td>Leon van der Walt</td>
                  </tr>
                  <tr>
                    <td width="5">&nbsp;</td>
                    <th align="left">Merchant Reference :</th>
                    <td width="5">&nbsp;</td>
                    <td>
                      <input
                        type="text"
                        id="txtMerchantReference"
                        name="txtMerchantReference"
                        value={MerchantReference}
                      />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <input
              type="hidden"
              id="Recipient"
              name="Recipient"
              value="Someone"
            />
            <input type="hidden" id="Mode" name="Mode" value={Mode} />
            <input type="hidden" name="MerchantID" value={MerchantID} />
            <input type="hidden" name="ApplicationID" value={ApplicationID} />
            <input type="hidden" name="Price" value={Price} />
            <input type="hidden" name="Amount" value={Price} />
            <input type="hidden" name="CurrencyCode" value={Currency} />
            <input
              type="hidden"
              name="RedirectSuccessfulURL"
              value={RedirectSuccess}
            />
            <input
              type="hidden"
              name="RedirectFailedURL"
              value={RedirectFailed}
            />
            <input type="hidden" name="DISCOUNT" value="0" />
            <input type="hidden" name="ITEMAMOUNT1" value="0" />
            <input type="hidden" name="ITEMDESCR1" value="desc 1" />
            <input
              type="hidden"
              name="ITEMREF1"
              value="Item Ref 15784 - 018179"
            />
            <input type="hidden" name="QTY1" value="1" />
            <input type="hidden" name="RECIPIENT" value="Sure Quote" />
            <input
              type="hidden"
              name="SHIPPINGADDRESS1"
              value="410 Lynnwood Road"
            />
            <input type="hidden" name="SHIPPINGADDRESS2" value="Lynnwood" />
            <input type="hidden" name="SHIPPINGADDRESS3" value="Pretoria" />
            <input type="hidden" name="SHIPPINGADDRESS4" value="South Africa" />
            <input type="hidden" name="SHIPPINGADDRESS5" value="0081" />
            <input type="hidden" name="SHIPPINGCOST" value="0" />
            <b>
              I Have carefully read the above terms and conditions, and agree to
              abide by them
            </b>
            :<br />I agree{" "}
            <input type="radio" name="tc[]" value="1" checked="true" /> I do not
            agree <input type="radio" name="tc[]" value="0" />
            <p />
            <input
              type="submit"
              value="Continue"
              onClick="return chkParms(this.form)"
            />
          </table>
        </form>
      </React.Fragment>
    );
  }
}

export default PaymentPlayground;



// WEBPACK FOOTER //
// ./src/views/Payment/PaymentPlayground.jsx